export { default } from "./src/bitbucket-search-integration";
